import {
  colors,
  ImpButton,
  ImpContainer,
  ImpFlex,
  ImpOtpField,
  ImpPad,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { useEffect, useState } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { MODAL_ENUM } from '../../app/applicationScreenSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import { setIncorrectOtpCode } from '../../app/otpScreenSlice';
import imprintLogo from '../../assets/icons/logo-imprint.svg';
import { ANALYTICS } from '../../firebase/firebase';
import { getContactSupportLink } from '../../utils/functionUtils';

interface OtpCardProps {
  title: string;
  showLogoHeader?: boolean;
  onFull: (e: string) => any;
  handleGoBack?: () => void;
  handleResend: () => void;
  bottomSubline?: string;
}

export default function OtpCardNew({
  title,
  showLogoHeader,
  onFull,
  handleResend,
  bottomSubline,
}: OtpCardProps) {
  const { merchantData, language, dispatch } = useImpState();
  const showLoginModal = useAppSelector(
    (state) =>
      state.applicationScreenSelector.showModal === MODAL_ENUM.showLoginModal
  );
  const [input, setInput] = useState('');
  const otpScreenState = useAppSelector((state) => state.otpScreenSelector);
  const [clearWithError, setClearWithError] = useState(false);
  const [clear, setClear] = useState(false);

  useEffect(() => {
    if (input !== '') {
      setClearWithError(false);
      setClear(false);
      dispatch(setIncorrectOtpCode(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  useEffect(() => {
    if (otpScreenState.isIncorrectOtpCode) {
      ANALYTICS.logEvent(EVENT.OTP_TRY_AGAIN_VIEWED);
      setClearWithError(true);
    }
  }, [otpScreenState.isIncorrectOtpCode]);

  const handleFull = (otp: string) => {
    if (otpScreenState.isIncorrectOtpCode) {
      ANALYTICS.logEvent(EVENT.OTP_TRY_AGAIN_SUBMITTED);
    } else {
      ANALYTICS.logEvent(EVENT.OTP_SUBMITTED);
    }
    onFull(otp);
  };

  const handleResendFn = () => {
    ANALYTICS.logEvent(EVENT.OTP_TRY_AGAIN_RESEND_CODE_CLICKED);
    setClear(true);
    dispatch(setIncorrectOtpCode(false));
    setClearWithError(false);
    handleResend();
  };

  return (
    <ImpContainer textAlign="center">
      {showLogoHeader && (
        <ImpFlex direction="column" align="center">
          <ImpContainer width="162px">
            <img draggable="false" alt="imprint logo" src={imprintLogo} />
          </ImpContainer>
          <ImpSpacer height={'xl'} />
        </ImpFlex>
      )}
      <ImpFlex direction="column" align="center">
        <ImpText typography="headline2" mobileTypography="headline3">
          {title}
        </ImpText>
        <ImpSpacer height={'xl'} />
      </ImpFlex>
      <ImpContainer>
        <ImpOtpField
          numInputs={6}
          onChange={setInput}
          onFull={handleFull}
          clearWithError={clearWithError}
          clear={clear}
          autoComplete="one-time-code"
        />
      </ImpContainer>

      <ImpPad padding="24px 0px 16px">
        <ImpText
          typography="body2"
          color={
            otpScreenState.isIncorrectOtpCode
              ? colors.content.onBackgroundError
              : colors.content.onBackgroundVariant
          }
        >
          {otpScreenState.isIncorrectOtpCode
            ? language.otpError2
            : bottomSubline}
        </ImpText>
      </ImpPad>

      <ImpFlex direction="column" align="center" justify="center">
        <ImpContainer width={'min(356px, 100%)'}>
          <ImpButton variant="secondary" size="fill" onClick={handleResendFn}>
            {language.sendCodeAgain}
          </ImpButton>
          <ImpSpacer height="xl" />
        </ImpContainer>
        <ImpButton
          variant="text"
          buttonStyle="branded"
          size="hug"
          onClick={() => {
            window
              .open(
                getContactSupportLink(
                  merchantData.productUUID,
                  language.selected
                ),
                '_blank'
              )
              ?.focus();
            if (showLoginModal) {
              ANALYTICS.logEvent(EVENT.RECOGNIZED_CONTACT_SUPPORT_CLICKED, {
                application_product_uuid: merchantData.productUUID,
              });
            }
          }}
        >
          {language.contactSupportBtn}
        </ImpButton>
      </ImpFlex>
    </ImpContainer>
  );
}
